import React, {useLayoutEffect, useRef} from 'react';
import ChatContact from './ChatContact';

const ChatUserList = (props) => {
    const {
        conversationList,
        selectConversation,
        selectedConversation,
        id,
        contactsNameSpace,
        user,
        isSupervisor,
        endConversationForOperator,
        ticketClick,
        blockUserClick,
        openForwardDialog,
        forwardConversation,
        company,
        loadOlderMessages,
        clearSelectedConversationFromStore
    } = props;

    const itemRefs = useRef({});
    const prevPositions = useRef({});
    const prevOrder = useRef([]);

    let sortedConversations = [...conversationList];
    sortedConversations.sort((a, b) => {
        const timeA = a.date ? new Date(a.date).getTime() : 0;
        const timeB = b.date ? new Date(b.date).getTime() : 0;
        return timeB - timeA;
    });

    useLayoutEffect(() => {
        const newOrder = sortedConversations.map(c => c.id);

        const orderIsSame = newOrder.length === prevOrder.current.length &&
            newOrder.every((id, index) => id === prevOrder.current[index]);

        if (!orderIsSame) {
            const newPositions = {};
            sortedConversations.forEach((conv) => {
                const domNode = itemRefs.current[conv.id];
                if (domNode) {
                    newPositions[conv.id] = domNode.getBoundingClientRect();
                }
            });

            sortedConversations.forEach((conv) => {
                const domNode = itemRefs.current[conv.id];
                if (!domNode) return;

                const prevRect = prevPositions.current[conv.id];
                const newRect = newPositions[conv.id];

                if (prevRect && newRect) {
                    const deltaY = prevRect.top - newRect.top;

                    if (deltaY !== 0) {
                        domNode.style.transition = 'none';
                        domNode.style.transform = `translateY(${deltaY}px)`;

                        domNode.offsetHeight;

                        domNode.style.transition = 'transform 300ms ease';
                        domNode.style.transform = '';
                    }
                }
            });

            prevPositions.current = newPositions;
        } else {
            const newPositions = {};
            sortedConversations.forEach((conv) => {
                const domNode = itemRefs.current[conv.id];
                if (domNode) {
                    newPositions[conv.id] = domNode.getBoundingClientRect();
                }
            });
            prevPositions.current = newPositions;
        }

        prevOrder.current = newOrder;

    }, [sortedConversations]);

    return (
        <ul id={id} className="list ul-list chat-contacts">
            {sortedConversations.map((conversation) => {
                const isSelected = selectedConversation.id === conversation.id;
                return (
                    <div
                        key={conversation.id}
                        ref={(el) => {
                            if (el) itemRefs.current[conversation.id] = el;
                        }}
                    >
                        <ChatContact
                            ticketClick={ticketClick}
                            blockUserClick={blockUserClick}
                            openForwardDialog={openForwardDialog}
                            endConversationForOperator={endConversationForOperator}
                            conversation={conversation}
                            contactNameSpace={contactsNameSpace}
                            selectConversation={selectConversation}
                            isSelected={isSelected}
                            user={user}
                            isSupervisor={isSupervisor}
                            forwardConversation={forwardConversation}
                            company={company}
                            loadOlderMessages={loadOlderMessages}
                            clearSelectedConversationFromStore={clearSelectedConversationFromStore}
                        />
                    </div>
                );
            })}
        </ul>
    );
};

export default ChatUserList;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/ConversationList.jsx